export var getIsClient = function () {
    return Boolean(typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement);
};
